import "core-js/modules/es.array.push.js";
import * as echarts from "echarts";
export default {
  name: "plotDialog",
  data() {
    return {
      listData: [],
      //历史数据
      weatherData: {},
      dialogVisible: false,
      // 设备id
      equipmentId: "",
      tempData: [],
      atmosphereData: []
    };
  },
  computed: {
    list() {
      return [{
        icon: require("../../assets/空气温度.png"),
        name: "空气温度",
        value: this.nullFormatter(this.weatherData.temperature) + "℃"
      }, {
        icon: require("../../assets/空气湿度.png"),
        name: "空气湿度",
        value: this.nullFormatter(this.weatherData.humidity) + "%"
      }, {
        icon: require("../../assets/风向风速.png"),
        name: "风向风速",
        value: this.nullFormatter(this.weatherData.windDirectionDescription) + this.weatherData.windLevel + "级"
      }, {
        icon: require("../../assets/大气压力.png"),
        name: "大气压力",
        value: this.nullFormatter(this.weatherData.atmosphere) + "hpa"
      }, {
        icon: require("../../assets/二氧化碳.png"),
        name: "二氧化碳",
        value: this.nullFormatter(this.weatherData.co2) + "ppm"
      }, {
        icon: require("../../assets/光照强度.png"),
        name: "光照强度",
        value: this.nullFormatter(this.weatherData.lightIntensity) + "lux"
      }, {
        icon: require("../../assets/PM2.5.png"),
        name: "PM2.5",
        value: this.nullFormatter(this.weatherData.pm)
      }];
    },
    isArrayEmpty(arr) {
      return function (arr) {
        return arr.every(element => element === null || element === undefined);
      };
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.initChart();
    // }, 1000);
  },
  methods: {
    // 关闭弹窗前触发
    handleClose() {},
    // 打开弹窗
    open(number, id) {
      this.dialogVisible = true;
      this.equipmentId = id;
      this.getData(number);
      this.getWeatherTrendData(number);
    },
    // 关闭dialog
    closeDialog() {
      this.dialogVisible = false;
    },
    // 打开时触发
    openChange() {
      let rows = JSON.parse(JSON.stringify(this.listData));
      console.log(rows, "rows");
    },
    nullFormatter(val) {
      if (val == null || val == undefined || val == "") {
        return "--";
      } else {
        return val;
      }
    },
    // 获取气象站数据
    async getData(number) {
      let params = {
        number: number
      };
      let {
        data,
        code
      } = await this.$api.getWeatherStationData(params);
      if (code == "200") {
        this.weatherData = data;
      }
      console.log(data, "气象站数据");
    },
    // 获取气象站温度趋势数据
    async getWeatherTrendData(number) {
      let params = {
        number
      };
      let {
        rows,
        code
      } = await this.$api.getWeatherListData(params);
      if (code == "200") {
        this.listData = rows;
        let xData = this.getChartsData(rows, "createTime");
        this.tempData = this.getChartsData(rows, "temperature");
        this.humData = this.getChartsData(rows, "humidity");
        this.co2Data = this.getChartsData(rows, "co2");
        this.lightData = this.getChartsData(rows, "lightIntensity");
        this.atmosphereData = this.getChartsData(rows, "atmosphere");
        this.pmData = this.getChartsData(rows, "pm");
        console.log(this.atmosphereData, "大气压力数据");
        this.initChart(0, xData, this.tempData, ["空气温度"]);
        this.initChart(1, xData, this.humData, ["空气湿度"]);
        this.initChart(2, xData, this.co2Data, ["二氧化碳浓度"]);
        this.initChart(3, xData, this.lightData, ["光照强度"]);
        this.initChart(4, xData, this.atmosphereData, ["大气压力"]);
        this.initChart(5, xData, this.pmData, ["浓度"]);
      }
      console.log(rows, "气象站历史数据");
    },
    // 获取不同字段，组成数组
    getChartsData(array, prop) {
      let arr = [];
      for (let i = 0; i < array.length; i++) {
        arr.push(array[i][prop]);
      }
      return arr;
    },
    initChart(index, xData, yData, legendData) {
      console.log(index, xData, yData, legendData, "this.$refs.echarts");
      let tempDom = this.$refs.temp;
      let humDom = this.$refs.hum;
      let co2Dom = this.$refs.co2;
      let lightDom = this.$refs.light;
      let atmosphereDom = this.$refs.atmosphere;
      let pmDom = this.$refs.pm;
      var chartDom = tempDom;
      if (index == 0) chartDom = tempDom;
      if (index == 1) chartDom = humDom;
      if (index == 2) chartDom = co2Dom;
      if (index == 3) chartDom = lightDom;
      if (index == 4) chartDom = atmosphereDom;
      if (index == 5) chartDom = pmDom;
      console.log(chartDom, "chartDom");
      var myChart = echarts.init(chartDom);
      // 定义颜色
      const color = "#19E3B4";

      // 设置阴影渐变
      const areaStyle = {
        normal: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: color
          }, {
            offset: 1,
            color: "rgba(25, 227, 180, 0)"
          }])
        }
      };

      // 配置项
      const option = {
        // 设置曲线的颜色
        color: [color],
        legend: {
          data: legendData,
          textStyle: {
            color: "#fff",
            // 设置文字颜色为白色
            fontSize: 7 // 设置文字大小为7px
          }
        },

        grid: {
          left: '20%'
        },
        xAxis: {
          type: "category",
          data: xData
        },
        yAxis: {
          type: "value"
        },
        // 设置阴影渐变
        series: [{
          name: legendData[0],
          type: "line",
          data: yData,
          areaStyle: areaStyle
        }]
      };
      option && myChart.setOption(option);
    }
  }
};